<template>
  <div class="about">
    <h2 class="title">Massive Search</h2>

    <AlbumSearch
      :is-massive-search="true"
      @search-massive="findAlbums($event)"
    />

    <div
      v-if="store.filteredItems"
      class="albums-info"
    >
      <div
        v-for="(data, provider, index) in store.filteredItems"
        :key="index"
        class="providers"
      >
        <AlbumCard
          v-for="album in data"
          :key="album.upc"
          :album="album"
          :provider="provider"
          @sync-album="syncAlbum($event)"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { useAlbumStore } from '@/stores/album'
import AlbumCard from '@/components/AlbumCard'
import AlbumSearch from '@/components/AlbumSearch'

export default {
  name: "AlbumsMassive",

  components: { AlbumCard, AlbumSearch },

  setup() {
    const store = useAlbumStore()

    return {
      store,
    }
  },

  methods: {
    /**
     * Search albums by (UPC-ISRC) depends on user selection
     * @param data => { type: Boolean, value: String[] }
     */
    findAlbums(data) {
      console.log(data)
      this.store.findAlbums(data)
    },

    /**
     * Call syncAlbum action from store and
     * show notify alert according request response
     * @param data => { provider: String, upc: String }
     */
    syncAlbum(data) {
      this.store.syncAlbum(data)
    },
  },
}
</script>

<style scoped lang="scss">
.albums-info {
  display: flex;
  width: 900px;
  margin: 3em auto;
  flex-direction: column;

  .providers {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
